export default "__VITE_ASSET__8fff9c00__"